import LegalDoc from '../components/LegalDoc';
import markdown from '../content/legal/refund-policy.md?raw';

export default function RefundPolicyScreen() {
  return <LegalDoc markdown={markdown} title="Refund and Cancellation Policy" />;
}
